import { slice, actions } from "./slice";

export { default as useOrderSelector } from "./useSelector";

export { default as orderThunks } from "./thunks";

export { actions as orderActions };

export default slice;
